import { useRef } from 'react';

export const simpleId = () => `_id${Math.random().toString(36).slice(2)}`;

export const useRandomId = () => useRef(simpleId()).current;
